import React from "react";
import { withStyles } from "@mui/styles";
import { Box, Typography } from "@mui/material";
import { useStyles } from "../indexFormStyles";

function ErrorMessage(props) {
  const { errors, modal = { open: false } } = props;

  return (
    errors.length > 0 &&
    !modal.open && (
      <Box
        sx={{
          width: "100%",
          textAlign: "center",
          justifyContent: "center",
          display: "flex",
        }}
      >
        {errors.map((item, key) => {
          return (
            <Box key={key} style={{ color: "red" }}>
              <Typography variant="caption" className="error-message">
                {item}
              </Typography>
            </Box>
          );
        })}
      </Box>
    )
  );
}

export default withStyles(useStyles, { withTheme: true })(ErrorMessage);
